import { render } from "./NotificationsIt.vue?vue&type=template&id=7cb24c32&scoped=true&ts=true"
import script from "./NotificationsIt.vue?vue&type=script&lang=ts"
export * from "./NotificationsIt.vue?vue&type=script&lang=ts"

import "./NotificationsIt.vue?vue&type=style&index=0&id=7cb24c32&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cb24c32"]])

export default __exports__